import { render, staticRenderFns } from "./MissingFinishings.vue?vue&type=template&id=2feb515f&scoped=true"
import script from "./MissingFinishings.vue?vue&type=script&lang=ts"
export * from "./MissingFinishings.vue?vue&type=script&lang=ts"
import style0 from "./MissingFinishings.vue?vue&type=style&index=0&id=2feb515f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb515f",
  null
  
)

export default component.exports